const chartTheme = {
    colors: {
        white: '#fff',
        amber: {400: '#fbbf24', 500: '#f59e0b'},
        blue: {400: '#60a5fa', 500: '#3b82f6'},
        emerald: {200: '#a7f3d0', 400: '#34d399', 500: '#10b981', 600: '#059669'},
        gray: {100: '#f3f4f6', 200: '#e5e7eb', 400: '#9ca3af', 500: '#6b7280', 600: '#4b5563', 700: '#374151', 800: '#1f2937'},
        indigo: {100: '#e0e7ff', 200: '#c7d2fe', 300: '#a5b4fc', 400: '#818cf8', 500: '#6366f1', 600: '#4f46e5', 700: '#4338ca', 800: '#3730a3', 900: '#312e81'},
        rose: {500: '#f43f5e', 600: '#e11d48'},
        sky: {400: '#38bdf8', 500: '#0ea5e9'},
        slate: {50: '#f8fafc', 100: '#f1f5f9', 300: '#cbd5e1', 400: '#94a3b8', 500: '#64748b', 800: '#1e293b', 900: '#0f172a'},
        violet: {500: '#8b5cf6'},
    },
    borderRadius: {full: '9999px', sm: '0.125rem'},
    fontSize: {sm: ['0.875rem', {lineHeight: '1.5715'}]},
    height: {2: '0.5rem', 3: '0.75rem'},
    margin: {1: '0.25rem', 1.5: '0.375rem', 2: '0.5rem', 3: '0.75rem', 4: '1rem'},
    width: {2: '0.5rem', 3: '0.75rem'},
};

export const tailwindConfig = () => ({theme: chartTheme});

export const hexToRGB = (h) => {
    let r = 0;
    let g = 0;
    let b = 0;
    if (h.length === 4) {
        r = `0x${h[1]}${h[1]}`;
        g = `0x${h[2]}${h[2]}`;
        b = `0x${h[3]}${h[3]}`;
    } else if (h.length === 7) {
        r = `0x${h[1]}${h[2]}`;
        g = `0x${h[3]}${h[4]}`;
        b = `0x${h[5]}${h[6]}`;
    }
    return `${+r},${+g},${+b}`;
};

export const formatValue = (value) => Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumSignificantDigits: 3,
    notation: 'compact',
}).format(value);

export const formatThousands = (value) => Intl.NumberFormat('en-US', {
    maximumSignificantDigits: 3,
    notation: 'compact',
}).format(value);
